export default "__VITE_ASSET__6At4PqE1__"